<template>
  <div class="wrap">
    <div class="header-right">
      <div class="header-user-con">
        <el-dropdown trigger="click" @command="langChange">
          <span class="el-dropdown-link">
            {{language}} <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided  command="zh">中文</el-dropdown-item>
            <el-dropdown-item divided  command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="ms-login">
      <el-row class="ms-title">
        <!-- <el-col :span="12"><span class="user-behavior" @click="handleLogin">登录</span></el-col> -->
        <el-col :span="24">
          <p class="user-behavior">{{$t("login.forget")}}</p>
        </el-col>
      </el-row>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="ms-content" size="large" autocomplete="off">
        <el-form-item label  prop="type" class="signupRadio">
          <el-radio-group v-model="verify_type">
            <el-radio-button :label="1">手机号验证</el-radio-button>
            <el-radio-button :label="2">邮箱验证</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label :error="emailErrMsg" prop="email" v-if="verify_type == 2">
          <el-input
            disabled
            v-model.trim="ruleForm.email"
            :placeholder="$t('forget.Email')"
            prefix-icon="el-icon-message"
          ></el-input>
        </el-form-item>
        <el-form-item label v-if="verify_type == 1">
          <el-input
            :placeholder="$t('forget.tel')"
            v-model.trim="ruleForm.phone"
            disabled
            prefix-icon="el-icon-mobile"
            @input="handleInputValidation">
            <template slot="prepend">{{ ruleForm.itu_code }}</template>
          </el-input>
        </el-form-item>
        <el-form-item class="captcha" label :error="captchaErrMsg" prop="captcha">
          <el-input
            v-model.trim="ruleForm.captcha"
            @input="handleInputValidation"
            prefix-icon="el-icon-check"
            :placeholder="$t('login.imgCode')"
          ></el-input>
          <div class="captcha-img">
            <img :src="captchaUrl" />
            <div @click="handleCaptcha" class="cover"></div>
          </div>
        </el-form-item>
        <!-- 短信验证码 -->
        <el-form-item class="send-code-info" label prop="sms_code" v-if="verify_type == 1">
          <el-input
            v-model.trim="ruleForm.sms_code"
            prefix-icon="el-icon-chat-line-square"
            :placeholder="$t('forget.msgCode')"
          ></el-input>
          <el-button
            class="send-code-btn"
            @click="handleSendCode"
            :disabled="showSendCodeBtn"
            type="primary"
          >{{ sendCodeBtnName }}</el-button>
        </el-form-item>
        <!-- 邮箱验证码 -->
        <el-form-item class="send-code-info" label prop="sms_code" v-if="verify_type == 2">
          <el-input
            v-model.trim="ruleForm.sms_code"
            prefix-icon="el-icon-chat-line-square"
            :placeholder="$t('forget.emailCode')"
          ></el-input>
          <el-button
            class="send-code-btn"
            @click="handleSendCode"
            :disabled="showSendCodeBtn"
            type="primary"
          >{{ sendCodeBtnName }}</el-button>
        </el-form-item>
        <el-form-item label prop="password">
          <el-input
            type="password"
            show-password
            autocomplete="password"
            v-model="ruleForm.password"
            prefix-icon="el-icon-lock"
            :placeholder="$t('login.setPwd')"
          ></el-input>
        </el-form-item>
        <el-form-item label prop="new_password">
          <el-input
            type="password"
            show-password
            autocomplete="new-password"
            v-model="ruleForm.new_password"
            prefix-icon="el-icon-lock"
            :placeholder="$t('login.setPwd')"
          ></el-input>
        </el-form-item>
        <el-form-item class="button-row">
          <el-button class="submit-button"  @click="handleCancel()">{{$t('companyInfo.cancel')}}</el-button>
          <el-button class="submit-button" type="primary" @click="submitForm('ruleForm')">{{$t('login.forget')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util'
const DOMAIN_CONFIG = require('@/utils/domainConfig')
export default {
  data() {
    return {
      verify_type: 1,
      captchaUrl: "",
      showSendCodeBtn: true,
      sendCodeBtnName: "获取验证码",
      timer: null,
      isValidEmail: false,
      emailErrMsg: "",
      isValidCode: false,
      captchaErrMsg: "",
      isValidPhone: false,
      phoneErrMsg: "",
      ruleForm: {
        email: "",
        itu_code: "+86",
        password: "",
        new_password: "",
        phone: "",
        sms_code: "",
        captcha: "",
      },
      language: '中文',
      logoImg: "../../../assets/img/logo.png"
    };
  },
  computed: {
    rules() {
      return {
        email: [
          { validator: this.validateEmail, trigger: "blur" },
          { type: 'email', message: this.$t('login.emailError'), trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: this.$t('login.pwdCheck'), trigger: "blur" },
          { min: 6, message: this.$t('login.min'), trigger: "blur" }
        ],
        new_password: [
          { required: true, message: this.$t('login.pwdCheck'), trigger: "blur" },
          { min: 6, message: this.$t('login.min'), trigger: "blur" },
          { validator: this.validateNewPsd, trigger: "blur" },
        ],
        captcha: [{ required: true, message: this.$t('login.codeCheck'), trigger: "blur" }],
        sms_code: [
          { required: true, message: this.$t('forget.smsCheck'), trigger: "blur" }
        ]
      }
    }
  },
  created() {
    let user = JSON.parse(util.getCookie("user"))
    this.ruleForm.phone = user.phone
    this.ruleForm.itu_code = user.itu_code
    this.ruleForm.email = user.email
    var lang = localStorage.getItem("lang")
    if(lang == 'en') {
      this.language = 'English'
    } else if (lang == 'zh') {
      this.language = '中文'
    }
    this.sendCodeBtnName = this.$t('forget.getCode')
    this.handleCaptcha();
  },
  methods: {
    // 中英文切换
    langChange(command) {
        this.$i18n.locale = command
        localStorage.setItem("lang", command)
        if(command == 'en') {
            this.language = 'English'
        } else if (command == 'zh') {
            this.language = '中文'
        }
        this.sendCodeBtnName = this.$t('forget.getCode')
    },
    // 邮箱验证
    validateEmail(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t('login.emailCheck')));
      } else {
        let params = {
          email: this.ruleForm.email
        };
        this.validateEmailPhone(params, callback)
      }
    },
    // 手机号验证
    validatePhone(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t('forget.phoneCheck')));
      } else {
        let reg = /^1[3-9]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error(this.$t('login.phoneError')));
        } else {
          let params = {
            mobile: this.ruleForm.phone,
            itu_code: this.ruleForm.itu_code
          };
          this.validateEmailPhone(params, callback)
        }
      }
    },
    // 二次密码校验
    validateNewPsd(rule, value, callback) {
      if (value !== this.ruleForm.password) {
        callback(new Error(this.$t('forget.reInputPsd')));
      } else {
        callback()
      }
    },
    // 邮箱-手机号验证接口
    validateEmailPhone(params, callback) {
      this.__postData(
        "registerCheck",
        params,
        res => {
          if(res.code == 1) {
            callback(new Error(res.msg));
          } else {
            callback();
          }
        },
        errmsg => {
          callback(new Error(errmsg));
        }
      );
    },
    handleCancel() {
      this.$router.back();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid, data) => {
        if (valid) {
          // 如果两次密码不一致，则提示错误
          if(this.ruleForm.password != this.ruleForm.new_password) {
            this.$message.error(this.$t('forget.reInputPsd'));
            return
          }
          // 判断是手机号验证还是邮箱验证
          let params = {
            new_password: this.ruleForm.new_password,
            sms_code: this.ruleForm.sms_code,
            verify_type: this.verify_type, //验证类型:1短信,2邮箱
          };

          this.__postData("reset", params, res => {
              if(res.code == 1) {
                this.$message.error(res.msg);
              } else {
                this.$message.success(this.$t('forget.congratulate'));
                // 重设成功跳转到应用列表页
                const currentDomain = window.location.hostname
                const user = JSON.parse(util.getCookie("user"))
                setTimeout(() => {
                  if (currentDomain === DOMAIN_CONFIG.OVERSEAS_DOMAIN) {
                    if(user.verify_code == 0 && !user.old_user) {
                      this.$router.push("/abroad/account/companyInfo")
                    }else {
                      this.$router.push("/abroad/app/list");
                    }
                  } else if (currentDomain === DOMAIN_CONFIG.DOMESTIC_DOMAIN) {
                    this.$router.push("/app/list")
                  }
                }, 200)
              }
            },
            errmsg => {
              this.$message.error(errmsg);
            }
          );
        } else {
          this.$message.error(this.$t('message.errorComplete'));
        }
      });
    },
    // 点击获取图形验证码
    handleCaptcha() {
      this.__postData("getCaptcha", {}, res => {
          if(res.code == 1) {
            this.$message.error(res.msg);
          } else {
            this.captchaUrl = res.image_data;
          }
        },
        errmsg => {
          this.$message.error(errmsg);
        }
      );
    },
    // 点击发送短信验证码
    // TODO:点击发送邮箱验证码
    handleSendCode() {
      if (this.timer) {
        return;
      }
      let params
      // TODO:判断是手机还是邮箱验证
      if(this.verify_type == 1) {
        params = {
          mobile: this.ruleForm.phone,
          captcha: this.ruleForm.captcha,
          itu_code: this.ruleForm.itu_code,
          type: 3, //1注册,2登录,3找回密码
        };
      } else {
        params = {
          email: this.ruleForm.email,
          captcha: this.ruleForm.captcha,
          type: 3, //1注册,2登录,3找回密码
        };
      }
      this.__postData(this.verify_type == 1?"getSms":"getEmailCode", params, res => {
          if(res.code == 1) {
            this.$message.error(res.msg);
            return
          }
          this.$message.success(this.verify_type == 1 ? this.$t('login.msg1') : this.$t('login.msg10'));
          let count = 60;
          this.sendCodeBtnName = count + "s";
          this.showSendCodeBtn = true;
          this.timer = setInterval(() => {
            if (count > 0 && count <= 60) {
              count--;
              this.sendCodeBtnName = count + "s";
            } else {
              this.showSendCodeBtn = false;
              clearInterval(this.timer);
              this.timer = null;
              this.sendCodeBtnName = this.$t('forget.getCode');
            }
          }, 1000);
        },
        errmsg => {
          this.$message.error(errmsg);
        }
      );
    },
    // handleCaptchaChange() {
    //   if (this.ruleForm.captcha.length != 4) {
    //     this.showSendCodeBtn = true;
    //   } else {
    //     this.showSendCodeBtn = !(this.ruleForm.phone.length == 11);
    //   }
    // },
    // handlePhoneChange() {
    //   if (this.ruleForm.phone.length != 11) {
    //     this.showSendCodeBtn = true;
    //   } else {
    //     this.showSendCodeBtn = !(this.ruleForm.captcha.length == 4);
    //   }
    // },
    handleInputValidation() {
      const isValidCaptcha = this.ruleForm.captcha.length === 4;
      const isValidPhone = this.ruleForm.phone.length >= 5 && this.ruleForm.phone.length <= 16;
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.ruleForm.email);
      if(this.verify_type === 1) { //手机号验证
        this.showSendCodeBtn = !(isValidCaptcha && isValidPhone);
      } else { //邮箱验证
        this.showSendCodeBtn = !(isValidCaptcha && isValidEmail);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: calc(100% - 66px);
}
.signupRadio .el-radio-group {
  width: 100%;
  display: flex;
}

.signupRadio .el-radio-button {
  flex: 1;
}

/deep/.signupRadio .el-radio-button__inner {
  width: 100%!important;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: left;
  font-size: 20px;
  margin-bottom: 20px;
}
.ms-login {
  position: absolute;
  right: 50%;
  left: 50%;
  top: 5%;
  transform: translateX(-50%);
  width: 494px;
  padding: 30px 47px;
  box-sizing: border-box;
  border-radius: 6px;
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
.submit-button {
  width: 100%;
  font-size: 14px;
  border-radius: 6px;
}
.toLogin {
  text-align: center;
  color: #3361FF;
  cursor: pointer;
}
.tip-msg {
  font-size: 14px;
  line-height: 20px;
  color: #9b9b9c;
  font-weight: 500;
}
.tip-reg {
  text-align: left;
  cursor: pointer;
  color: #3361FF;
}
.tip-reg:hover {
  color: #409eff;
}


.user-behavior {
  cursor: pointer;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.devPlatform {
  font-size: 33px;
  font-weight: 700;
}
.captcha .el-input {
  width: 68%;
  display: inline-block;
}
.ms-content .el-input__inner {
  background: rgba(246, 248, 250, 1);
  line-height: normal;
  font-size: 14px;
  color: rgba(98, 109, 116, 1);
}
.captcha-img {
  height: 40px;
  width: 30%;
  float: right;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
}
.captcha-img img {
  width: 100%;
  height: 40px;
}
.captcha-img:hover .cover {
  z-index: 1;
}
.cover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: rgba(123, 139, 137, 0.6);
  background-image: url(../../assets/img/captcha-refresh.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
}
.el-checkbox {
  color: #9b9b9c;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #9b9b9c;
}
.el-input-group__append,
.el-input-group__prepend {
  background: rgba(147, 165, 186, 1);
  border-radius: 8px 0px 0px 8px;
  color: rgba(255, 255, 255, 1);
}
 .ms-content .el-input__inner::-webkit-input-placeholder {
  color: rgba(98, 109, 116, 1);
}
.ms-content .el-input__inner::-moz-placeholder {
  color: rgba(98, 109, 116, 1);
} /* firefox 19+ */
.ms-content .el-input__inner:-ms-input-placeholder {
  color: rgba(98, 109, 116, 1);
} /* Internet Explorer 10+ */
.ms-content .el-input__inner:-moz-placeholder {
  color: rgba(98, 109, 116, 1);
} /* firefox 14-18 */

.send-code-info .el-input {
  width: 68%;
  display: inline-block;
}
.send-code-btn {
  float: right;
  width: 30%;
  height: 40px;
  padding: 0;
}
.cover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: rgba(123, 139, 137, 0.6);
  background-image: url(../../assets/img/captcha-refresh.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
}

.header-right{
  position: absolute;
  top: 12px;
  right: 60px;
  z-index: 10;
}
::v-deep .el-dropdown {
  cursor: pointer;
}
.header-right .el-dropdown{
  color: rgba(0, 0, 0, 0.85);
}

/* .signupRadio .el-radio--medium.is-bordered .el-radio__inner{
  background:none!important;
  border:none!important;
  display: none!important;
} */
.el-radio__label{
  padding-left:0px;
}
.el-radio--medium.is-bordered{
  padding-bottom:5px;
  border-radius: 0;
  border: none;
  padding: 10px 0;
  border-bottom: 2px solid transparent;
}
.el-radio--medium.is-bordered .el-radio__input{
  display: none!important;
}
.signupRadio .el-radio.is-checked {
  border-bottom-color: #3361FF;
}
.el-radio__inner::after{
  display: none;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner{
  box-shadow: none;
}
.button-row {
  display: flex;
  justify-content: space-around;
  
  .submit-button {
    width: auto;  
    flex: 1;      
  }
}
</style>
